import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { Box, Text } from 'components/Wrapped';

const ExchangeWidgetContainer = ({
  children,
  theme,
  hasHeading,
  title,
  gridArea,
  padding = { top: '0px', bottom: '12px', left: '16px', right: '16px' },
}) => (
  <Box
    background="#0A171E"
    pad={padding}
    className="has-full-height flex-column"
    elevation={theme.dark ? 'none' : 'xsmall'}
    gridArea={gridArea}
  >
    {hasHeading && (
      <Box pad={{ top: '11px', bottom: '9px', left: '0px', right: '0px' }} className="draggableHandle">
        <Box pad="none">
          <Text color="white" weight={600}>
            {title}
          </Text>
        </Box>
      </Box>
    )}
    <div style={{ flex: '1 1 auto', width: '100%', height: 1 }} className="is-flex flex-column react-virtualized-container-fix">
      {children}
    </div>
  </Box>
);

ExchangeWidgetContainer.propTypes = {
  children: PropTypes.node,
  hasHeading: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

ExchangeWidgetContainer.defaultProps = {
  hasHeading: false,
};

export default withTheme(ExchangeWidgetContainer);
